<section class="results-pane-value">
  <span class="Auto_Result" >{{displayValue | translate}}</span>
</section>
<ng-template #editableTemplate>
    <input class="derived-field-disabled" type="text" placeholder="{{displayValue | stringTranslate}}">
</ng-template>
